import { useQuery } from "react-query";
import { fetchTeamDailyCost, ITeamDailyCostSummary } from "../api/aiMetricsApi";
import { ADO_QUERY_KEYS, adoPriorQueryKey } from "./adoQueryKeys";

const STALE_TIME = 5 * 60 * 1000;

export const useTeamDailyCost = (
  teamIds: string[],
  startDate: Date,
  endDate: Date,
  priorStartDate: Date,
  priorEndDate: Date,
  comparisonEnabled = true,
) => {
  const sortedTeams = JSON.stringify([...teamIds].sort());

  const current = useQuery<ITeamDailyCostSummary, Error>(
    [
      ADO_QUERY_KEYS.teamDailyCost,
      sortedTeams,
      startDate.toISOString(),
      endDate.toISOString(),
    ],
    () => fetchTeamDailyCost(teamIds, startDate, endDate),
    { staleTime: STALE_TIME, enabled: teamIds.length > 0 },
  );

  const prior = useQuery<ITeamDailyCostSummary, Error>(
    [
      adoPriorQueryKey(ADO_QUERY_KEYS.teamDailyCost),
      sortedTeams,
      priorStartDate.toISOString(),
      priorEndDate.toISOString(),
    ],
    () => fetchTeamDailyCost(teamIds, priorStartDate, priorEndDate),
    {
      staleTime: STALE_TIME,
      enabled: comparisonEnabled && teamIds.length > 0,
    },
  );

  return { current, prior };
};
